import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgId = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .id-user-fill {\n        fill: #002ff4;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "id-user-fill",
			d: "M741.41,778.53H58.59v-61.97c1.11-120.63,99.59-227.98,221.34-234.62,66.41-3.32,138.34-1.11,205.86,0,17.7,1.1,33.21,0,50.9,2.21,99.59,13.28,181.49,89.64,200.32,188.14,6.62,35.41,3.32,70.83,4.4,106.24Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "id-user-fill",
			d: "M429.34,446.53c-160.49,24.34-293.29-129.49-236.85-284.42C244.53,17.13,431.56-26.03,543.33,81.32c128.37,121.73,59.74,338.65-113.99,365.21Z"
		})
	]
});
export default SvgId;
